import { render, staticRenderFns } from "./homeaside.vue?vue&type=template&id=d2ea3bbe&"
import script from "./homeaside.vue?vue&type=script&scoped=true&lang=js&"
export * from "./homeaside.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./homeaside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports